export enum LibraryTypeEnum {
  Channel = 'Channel',
  Library = 'Library',
  User = 'User',
}
